import { MutableRefObject } from 'react';
import { SubmitActions, SubmitData, UIElement } from '@adyen/adyen-web';
import * as Yup from 'yup';
// import { Field } from 'formik';
import { Address } from './ProfileModel';

export enum PaymentVendors {
  Adyen = 'adyen',
  RazorPay = 'razorpay',
  Dlocal = 'dlocal',
  Worldpay = 'worldpay',
}

export interface AdyenCreatePaymentVariables {
  requestData: AdyenCreatePaymentRequest;
  dropinComponent: any;
  address: Address;
  onSuccessfulSave: () => void;
}

export interface AdyenPaymentMethod {
  brand: string;
  checkoutAttemptId: string;
  encryptedCardNumber: string;
  encryptedExpiryMonth: string;
  encryptedExpiryYear: string;
  encryptedSecurityCode: string;
  holderName: string;
  taxNumber: string;
  type: string;
}

export interface AdyenCreatePaymentRequest {
  paymentMethod: AdyenPaymentMethod;
  tokenize?: boolean;
  isDefault?: boolean;
  customerEmail: string;
  verifiedCountryCode: string;
  verifiedRegionCode: string;
  addressId: number;
}

export interface AdyenCreatePaymentResponse {
  data: {
    action: any;
    orderTrackingNumber: string;
  };
}

export type AdyenSubmitCallbackFunction = (
  state: {
    data: {
      paymentMethod: {
        type: string;
        holderName: string;
        encryptedCardNumber: string;
        encryptedExpiryMonth: string;
        encryptedExpiryYear: string;
        encryptedSecurityCode: string;
      };
    };
  },
  element: any,
) => Promise<void>;

export interface AdyenDropinElement {
  submit: () => void;
  unmount: () => void;
}

export interface AdyenIntegrationRefs {
  adyenDropinRef: MutableRefObject<AdyenDropinElement | null>;
}

export const adyenSchema = Yup.object({
  primaryPaymentMethod: Yup.boolean(),
});

export type AdyenFormFields = Yup.InferType<typeof adyenSchema>;

export interface AdyenProps {
  id: string;
  editing: boolean;
  // fieldNames: Record<keyof AdyenFormFields, keyof TFieldValues & string>;
  clientKey: string;
  environment:
    | 'test'
    | 'live'
    | 'live-us'
    | 'live-au'
    | 'live-apse'
    | 'live-in';
  handleFormStart: () => void;
  refs: AdyenIntegrationRefs;
  onSubmitCallback: (
    state: SubmitData,
    component: UIElement,
    actions: SubmitActions,
  ) => Promise<void>;
}
